"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var NoPriceForMotorTierModal = /** @class */ (function (_super) {
    __extends(NoPriceForMotorTierModal, _super);
    function NoPriceForMotorTierModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoPriceForMotorTierModal.prototype.render = function () {
        if (this.props.isNB) {
            return this.getNBModal();
        }
        return this.getMTAModal();
    };
    NoPriceForMotorTierModal.prototype.getMTAModal = function () {
        var _this = this;
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.props.closeModal });
        var isSupportPortal = this.props.interaction.process.includes("SupportPortal");
        return (React.createElement(reactstrap_1.Modal, { className: "info-modal ineligible-for-motor-tier-modal", isOpen: this.props.isOpen, toggle: this.props.closeModal },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.props.closeModal, close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "info selected icon" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-600" }, "We need to move you to a new policy for the cover level selected."))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto ineligible-for-motor-tier-modal-body" },
                React.createElement("div", null, "If you go back to the summary page, you can review our cover levels again or select your existing cover level to continue with your change."),
                React.createElement("div", null,
                    React.createElement("p", { className: "font-weight-semi-bold separate-section" }, "To make your change and switch your cover level:"),
                    React.createElement("ol", null,
                        React.createElement("li", null, "\u2018Cancel changes\u2018 below and select \u2018our products\u2018 from your account homepage."),
                        React.createElement("li", null, "Get a quote for your desired cover level and buy a new policy."),
                        React.createElement("li", null, "Cancel your existing policy and select \u2018buying a new Allianz Car Insurance policy\u2018 as the reason")))),
            React.createElement(reactstrap_1.ModalFooter, { className: "custom-margin-mobile-cut-sides" },
                React.createElement("button", { className: "btn my-0 btn-back", onClick: function () { return _this.cancelChanges(isSupportPortal, _this.props.interaction.userReference); } }, "Cancel changes"),
                React.createElement("button", { type: "button", className: "btn btn-primary btn-add", onClick: this.props.closeModal }, "Go back to summary page"))));
    };
    NoPriceForMotorTierModal.prototype.getNBModal = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.props.closeModal });
        return (React.createElement(reactstrap_1.Modal, { className: "info-modal", isOpen: this.props.isOpen, toggle: this.props.closeModal },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.props.closeModal, close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "info selected icon" }),
                    React.createElement("div", { className: "text-blue-2 font-weight-600" }, "You'll need a new quote for the cover level you've selected."))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto ineligible-for-motor-tier-modal-body" },
                React.createElement("div", null,
                    "You can go back to review our cover levels again or ",
                    React.createElement("a", { className: "hyperlink", href: "/dashboard" }, "get a new quote"),
                    " for our Allianz Silver cover."),
                React.createElement("div", null,
                    React.createElement("p", { className: "font-weight-semi-bold separate-section" }, "Don\u2019t worry \u2013 we\u2019ll save all your quotes in your account if you want to come back later."))),
            React.createElement(reactstrap_1.ModalFooter, { className: "custom-margin-mobile-cut-sides" },
                React.createElement("button", { className: "btn my-0 btn-text-padded", onClick: this.props.closeModal }, "Go back to quote page"),
                React.createElement("button", { type: "button", className: "btn btn-primary btn-add", onClick: this.goToQuotePage }, "Get a new quote"))));
    };
    NoPriceForMotorTierModal.prototype.goToQuotePage = function () {
        window.location.href = "/products";
    };
    NoPriceForMotorTierModal.prototype.cancelChanges = function (isSupportPortal, userReference) {
        isSupportPortal ? window.location.href = "/customers/".concat(userReference) : window.location.href = "/dashboard";
    };
    return NoPriceForMotorTierModal;
}(React.Component));
exports.default = NoPriceForMotorTierModal;
//# sourceMappingURL=NoPriceForMotorTierModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/NoPriceForMotorTierModal.js
// module id = 1250
// module chunks = 0